












import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faCheckCircle)

import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    value: Boolean,
    readonly: Boolean,
    disabled: Boolean
  },

  setup(props, { emit }) {
    const toggle = () => {
      if (props.readonly || props.disabled) return

      emit('input', !props.value)
    }

    return {
      toggle
    }
  }
})
